import React, { useEffect, useState } from 'react';
import { Box, Paper, Button, Typography, useMediaQuery } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useAppDispatch } from '../../app/hooks';
import { fetchUsers } from '../UserManagement/UserSlice';
import NewProject from './NewProject';
import UserviewList from 'views/application/users/list/Style1/index';

function ProjectManagement() {
  const [showNew, setShowNew] = useState(false);
  const dispatch = useAppDispatch();
  const isSmallScreen = useMediaQuery('(max-width:600px)'); 
  

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        sx={{ p: isSmallScreen ? 2 : 4 }} 
      >
        {/* Header Section */}
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
          <Box
            display="flex"
            alignItems="center"
            width="100%"
            sx={{ justifyContent: isSmallScreen ? 'center' : 'flex-start' }} // Center button on small screens
          >
            <Button
              className="bold-text"
              sx={{
                bgcolor: 'var(--color-ocean-default)',
                color: 'var(--color-offwhite)',
                py: 2,
                px: 4,
                ':hover': {
                  bgcolor: 'var(--color-ocean-highlight)',
                  color: 'var(--color-dark-gray)'
                },
                height: '56px',
                maxWidth: '358px',
                width: '100%', // Make button full width on small screens
                border: 'solid'
              }}
              onClick={() => setShowNew(true)}
              size="large"
              variant="contained"
              startIcon={<AddIcon />}
            >
              Onboard Community
            </Button>
          </Box>
        </Box>

        {/* Content Section */}
        <Paper
          sx={{
            padding: isSmallScreen ? '10px' : '20px 30px', // Adjust padding for small screens
            backgroundColor: 'var(--color-dark-gray)',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflow: 'auto'
          }}
        >
          {/* User List */}
          <UserviewList />
        </Paper>
      </Box>

      {/* New Project Popup */}
      {showNew && <NewProject open={showNew} onClose={() => setShowNew(false)} />}
    </>
  );
}

export default ProjectManagement;
